/*
 * Hundevennen – tekstfiks
 * 1) Tall og enhet holdes sammen i produkttitler (f.eks. "85 g", "3200 W"),
 *    slik at linjen aldri brytes mellom tallet og enheten.
 * 2) Knappene på produktkortene bruker korte tekster ("Legg til", "Velg"),
 *    så de ikke kuttes på smale kort.
 */
(function () {
  var NBSP = ' ';
  var TITLE_SELECTOR = '.product-card__title, .product__title';
  var BUTTON_SELECTOR = '.product-card__action-text';
  var SHORT_TEXT = {
    'Legg i handlekurv': 'Legg til',
    'Velg alternativer': 'Velg'
  };

  function fixTitle(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue.replace(/(\d) (?=\S)/g, '$1' + NBSP);
      if (value !== node.nodeValue) node.nodeValue = value;
    }
  }

  function fixButton(el) {
    var text = el.textContent.trim();
    if (SHORT_TEXT[text]) el.textContent = SHORT_TEXT[text];
  }

  function run(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.closest) {
      var title = root.closest(TITLE_SELECTOR);
      if (title) fixTitle(title);
      var button = root.closest(BUTTON_SELECTOR);
      if (button) fixButton(button);
    }
    root.querySelectorAll(TITLE_SELECTOR).forEach(fixTitle);
    root.querySelectorAll(BUTTON_SELECTOR).forEach(fixButton);
  }

  var pending = [];
  var scheduled = false;
  function flush() {
    scheduled = false;
    var nodes = pending;
    pending = [];
    nodes.forEach(run);
  }

  function start() {
    run(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) pending.push(n);
          else if (n.nodeType === 3 && n.parentElement) pending.push(n.parentElement);
        });
      });
      if (pending.length && !scheduled) {
        scheduled = true;
        requestAnimationFrame(flush);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
